<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h1>Account Information</h1>
      </v-card-title>
      <v-card-text>
        <div v-if="user">
          <p><strong>Name:</strong> {{ user.displayName }}</p>
          <p><strong>Email:</strong> {{ user.email }}</p>
          <p><strong>Role:</strong> {{ user.role }}</p>
        </div>
        <div v-else>
          <p>Loading user data...</p>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'Account',
  props: ['user'],
};
</script> 